import actions from './actions'

export default function OfferArticlesReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_OFFERARTICLE:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_OFFERARTICLE:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_OFFERARTICLE:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_OFFERARTICLE:
      return {
        ...state,
        editing: { offerArticleID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_OFFERARTICLE_RECIEVED ||
      actions.UPDATE_OFFERARTICLE_RECIEVED ||
      actions.DELETE_OFFERARTICLE_RECIEVED:
      return {
        ...state,
        editing: { offerArticleID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    case actions.NEW_OFFERARTICLE2_RECIEVED:
      return {
        ...state,
        loading: false,
        saveSuccess: false,
      }
    default:
      return state
  }
}
